import React from "react";
import { UsersIcon, DashboardIcon } from "@assets/svgIcons";
import "./styles.scss";

const StatsGrid = ({ totalCount, filteredCount }) => (
  <div className="stats-grid">
    <div className="stat-card">
      <div className="stat-icon">
        <UsersIcon />
      </div>
      <div className="stat-info">
        <h3 className="stat-number">{totalCount}</h3>
        <p className="stat-label">Total Submissions</p>
      </div>
    </div>
    <div className="stat-card">
      <div className="stat-icon">
        <DashboardIcon />
      </div>
      <div className="stat-info">
        <h3 className="stat-number">{filteredCount}</h3>
        <p className="stat-label">Filtered Results</p>
      </div>
    </div>
  </div>
);

export default StatsGrid;
